import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { GuiFlowService } from 'src/app/___LOGIC/__gui/gui-flow.service';
import { ResolverService } from 'src/app/___LOGIC/__common/resolver.service';
import { SHOPIFY_PRODUCTS } from './products-data'; // adjust path as needed
import { HandleError, HttpErrorHandlerService } from 'src/app/___LOGIC/http/http-error-handler.service';
import { FunctionsService } from 'src/app/___LOGIC/__common/functions.service';

const HTTP_OPTIONS = {

  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'my-auth-token'
  })
};

@Component({
  selector: 'app-shopify-simulator',
  templateUrl: './shopify-simulator.component.html',
  styleUrls: ['./shopify-simulator.component.css']
})
export class ShopifySimulatorComponent implements OnInit {

  loading = false;
  randomEmail = this.commonFunctions.generateRandomNumber6Digit()+'@mail.com';
  order1 = {
    "id": 6195428458799,
    "admin_graphql_api_id": "gid:\/\/shopify\/Order\/6195428458799",
    "app_id": 580111,
    "browser_ip": "79.152.33.66",
    "buyer_accepts_marketing": false,
    "cancel_reason": null,
    "cancelled_at": null,
    "cart_token": "Z2NwLXVzLWNlbnRyYWwxOjAxSk0xMTU2Vk04OE1EMjNHSDhXUENEQUM4",
    "checkout_id": 38141419290927,
    "checkout_token": "0c5edfedfde0d669737516b6ef79aa22",
    "client_details": {
        "accept_language": "es-CR",
        "browser_height": null,
        "browser_ip": "79.152.33.66",
        "browser_width": null,
        "session_hash": null,
        "user_agent": "Mozilla\/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit\/537.36 (KHTML, like Gecko) Chrome\/132.0.0.0 Safari\/537.36"
    },
    "closed_at": null,
    "confirmation_number": "5T0TUR0I6",
    "confirmed": true,
    "contact_email": "contact@mail.com",
    "created_at": "2025-02-13T19:29:07-06:00",
    "currency": "USD",
    "current_subtotal_price": "89.00",
    "current_subtotal_price_set": {
        "shop_money": {
            "amount": "89.00",
            "currency_code": "USD"
        },
        "presentment_money": {
            "amount": "89.00",
            "currency_code": "USD"
        }
    },
    "current_total_additional_fees_set": null,
    "current_total_discounts": "0.00",
    "current_total_discounts_set": {
        "shop_money": {
            "amount": "0.00",
            "currency_code": "USD"
        },
        "presentment_money": {
            "amount": "0.00",
            "currency_code": "USD"
        }
    },
    "current_total_duties_set": null,
    "current_total_price": "89.00",
    "current_total_price_set": {
        "shop_money": {
            "amount": "89.00",
            "currency_code": "USD"
        },
        "presentment_money": {
            "amount": "89.00",
            "currency_code": "USD"
        }
    },
    "current_total_tax": "0.00",
    "current_total_tax_set": {
        "shop_money": {
            "amount": "0.00",
            "currency_code": "USD"
        },
        "presentment_money": {
            "amount": "0.00",
            "currency_code": "USD"
        }
    },
    "customer_locale": "es-CR",
    "device_id": null,
    "discount_codes": [],
    "email": this.randomEmail,
    "estimated_taxes": false,
    "financial_status": "pending",
    "fulfillment_status": null,
    "landing_site": "\/products\/guia-para-eleccion-de-universidad-y-plan-de-estudios",
    "landing_site_ref": null,
    "location_id": null,
    "merchant_of_record_app_id": null,
    "name": "#voyjaleas1120pedido",
    "note": null,
    "note_attributes": [
        {
            "name": "user_id",
            "value": "181"
        },
        {
            "name": "order_token",
            "value": ""
        }
    ],
    "number": 120,
    "order_number": 1120,
    "order_status_url": "https:\/\/60481f-11.myshopify.com\/87605707055\/orders\/e36f0ceae73d07b9136f04c3d0aae743\/authenticate?key=106f5e6a5b3d61b78f3b8076abcd1d06",
    "original_total_additional_fees_set": null,
    "original_total_duties_set": null,
    "payment_gateway_names": [
        "SINPE M\u00f3vil"
    ],
    "phone": null,
    "po_number": null,
    "presentment_currency": "USD",
    "processed_at": "2025-02-13T19:29:04-06:00",
    "reference": null,
    "referring_site": "http:\/\/localhost:4200\/",
    "source_identifier": null,
    "source_name": "web",
    "source_url": null,
    "subtotal_price": "89.00",
    "subtotal_price_set": {
        "shop_money": {
            "amount": "89.00",
            "currency_code": "USD"
        },
        "presentment_money": {
            "amount": "89.00",
            "currency_code": "USD"
        }
    },
    "tags": "",
    "tax_exempt": false,
    "tax_lines": [],
    "taxes_included": false,
    "test": false,
    "token": "e36f0ceae73d07b9136f04c3d0aae743",
    "total_discounts": "0.00",
    "total_discounts_set": {
        "shop_money": {
            "amount": "0.00",
            "currency_code": "USD"
        },
        "presentment_money": {
            "amount": "0.00",
            "currency_code": "USD"
        }
    },
    "total_line_items_price": "89.00",
    "total_line_items_price_set": {
        "shop_money": {
            "amount": "89.00",
            "currency_code": "USD"
        },
        "presentment_money": {
            "amount": "89.00",
            "currency_code": "USD"
        }
    },
    "total_outstanding": "89.00",
    "total_price": "89.00",
    "total_price_set": {
        "shop_money": {
            "amount": "89.00",
            "currency_code": "USD"
        },
        "presentment_money": {
            "amount": "89.00",
            "currency_code": "USD"
        }
    },
    "total_shipping_price_set": {
        "shop_money": {
            "amount": "0.00",
            "currency_code": "USD"
        },
        "presentment_money": {
            "amount": "0.00",
            "currency_code": "USD"
        }
    },
    "total_tax": "0.00",
    "total_tax_set": {
        "shop_money": {
            "amount": "0.00",
            "currency_code": "USD"
        },
        "presentment_money": {
            "amount": "0.00",
            "currency_code": "USD"
        }
    },
    "total_tip_received": "0.00",
    "total_weight": 0,
    "updated_at": "2025-02-13T19:29:08-06:00",
    "user_id": null,
    "billing_address": {
        "first_name": "Sebasti\u00e1n",
        "address1": "Calle del Capit\u00e1n Blanco Argibay, 103",
        "phone": null,
        "city": "Madrid",
        "zip": "28029",
        "province": "Madrid",
        "country": "Spain",
        "last_name": "Jim\u00e9nez Benavides",
        "address2": null,
        "company": null,
        "latitude": 40.4668284,
        "longitude": -3.7038464,
        "name": "Sebasti\u00e1n Jim\u00e9nez Benavides",
        "country_code": "ES",
        "province_code": "M"
    },
    "customer": {
        "id": 8224588005679,
        "email": this.randomEmail,
        "created_at": "2024-04-18T19:46:14-06:00",
        "updated_at": "2025-02-13T19:29:07-06:00",
        "first_name": "Sebasti\u00e1n",
        "last_name": "Jim\u00e9nez Benavides",
        "state": "disabled",
        "note": null,
        "verified_email": true,
        "multipass_identifier": null,
        "tax_exempt": false,
        "phone": null,
        "email_marketing_consent": {
            "state": "not_subscribed",
            "opt_in_level": "single_opt_in",
            "consent_updated_at": null
        },
        "sms_marketing_consent": null,
        "tags": "",
        "currency": "USD",
        "tax_exemptions": [],
        "admin_graphql_api_id": "gid:\/\/shopify\/Customer\/8224588005679",
        "default_address": {
            "id": 10729400762671,
            "customer_id": 8224588005679,
            "first_name": "Sebasti\u00e1n",
            "last_name": "Jim\u00e9nez Benavides",
            "company": null,
            "address1": "Calle del Capit\u00e1n Blanco Argibay, 103",
            "address2": null,
            "city": "Madrid",
            "province": "Madrid",
            "country": "Spain",
            "zip": "28029",
            "phone": null,
            "name": "Sebasti\u00e1n Jim\u00e9nez Benavides",
            "province_code": "M",
            "country_code": "ES",
            "country_name": "Spain",
            "default": true
        }
    },
    "discount_applications": [],
    "fulfillments": [],
    // PRODUCTS
    "line_items": [],
    "payment_terms": null,
    "refunds": [],
    "shipping_address": null,
    "shipping_lines": []
  };

  statusArray = [
    {
        label: 'Pending',
        value: 'pending'
    },
    {
        label: 'Verifying Payment',
        value: 'paymentPending'
    },
    {
        label: 'Paid',
        value: 'paid'
    },
    {
        label: 'Unpaid',
        value: 'unpaid'
    }
  ]
  
  stockShopifyProducts = [];

  private handleError: HandleError;

  constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandlerService,private guiFlow: GuiFlowService,private resolver: ResolverService,private commonFunctions: FunctionsService) { 
    this.handleError = httpErrorHandler.createHandleError('ApiEmailService');
  }

  ngOnInit(): void {
    const cfg = (window as any).__APP_CONFIG__;
    this.stockShopifyProducts = Object.values(cfg.shopifyProducts);
  }

  getProductByVariantId(variantId: any) {
    return SHOPIFY_PRODUCTS.find(item => item.variant_id == variantId);
  }

  post(){
    let apiUrl = 'https://app.voyjaleas.com/myapp/shopifyConnector/OrderCreated.php';
    return this.http.post<any>(apiUrl, this.order1, HTTP_OPTIONS).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError('addingNewElement', this.order1))
    );
  }

  simulateOrder(){
    this.loading = true;
    this.post().subscribe(
      (response) => {
            this.loading = false;
          this.guiFlow.openSimpleSnackBar('Order Webhook Simulated','success');
        },
    (error) => {
        console.log(error);
        this.guiFlow.openSimpleSnackBar('Error','error');
        this.loading = false;
      }
    );
  }

  updateSelection(selection: any,product){
    debugger
    product.variant_id = selection;
  }

  addProductToOrder(selection: any){
    debugger
    let prodToAdd = this.getProductByVariantId(selection.value.variantId);
    this.order1.line_items.push(prodToAdd);
  }

  updateStatusSelection(selection: any){
    debugger
    this.order1.financial_status = selection;
    /* this.inputValue = selection.name + ' '+selection.lastname;
    this.selectedObj.emit(selection);
    this.editingMode = false; */
    /* this.crudFieldsData.addValueToFieldInObj(this.data.fieldName, this.inputValue,this.data.crudId); */
  }

  isFormValid(){
    return this.order1.financial_status.length>0 && this.order1.note_attributes[1].value;
  }


}
